export default {
  title: 'מעבר לדף {{name}}',
  language: 'English',
  items: {
    main: {
      title: 'ראשי',
    },
    info: {
      title: 'למידע אישי',
    },
    service: {
      title: 'השירות',
    },
    team: {
      title: 'הצוות',
    },
    contact: {
      title: 'צרו קשר',
    },
  },
};
